import React, {Fragment, useContext, useEffect, useState} from "react";
import {useAtom} from "jotai";
import FilterContext from "../Context/FilterContext";
import {applyStateAtom} from "../utils/globals";

const CheckBoxes = ({ id, label, options = [] }) => {
    const { activeFilters, setActiveFilters, setActiveFiltersCounter, setApplyFilters} = useContext(FilterContext);
    const [applyState, setApplyState] = useAtom(applyStateAtom);
    const { effortLevel, mainIngredients, cookingTime, course, diet, style, fuelType, featured } = applyState;
    const [counter, setCounter] = useState(0);

    useEffect(() => {
        const container = document.getElementById(`${id}`);
        const checkboxes = container.querySelectorAll('.js-filter-checkbox');
        let countCheck = 0;

        for (let i=0; i< checkboxes.length; i+=1) {
            if (checkboxes[i].checked){
                countCheck += 1;
            }
        }

        setCounter(countCheck);
    });

    function toggleAccordian(e) {
        if (e.currentTarget.parentNode.classList.contains('active')) {
            e.currentTarget.parentNode.classList.remove('active');
        } else {
            const filterAccordions = document.querySelectorAll('.b-recipes-advanced-filter__checkbox-wrapper');
            for (let i=0; i< filterAccordions.length; i+=1) {
                filterAccordions[i].classList.remove('active');
            }

            e.currentTarget.parentNode.classList.add('active');
        }
    }

    function handleClick(payload) {
        const found = activeFilters.some(el => el.id === payload.id);
        if (!found) {
            const newFilters = activeFilters.concat({id:payload.id, name:payload.name, taxonomy:payload.taxonomy});

            setActiveFilters(newFilters);
            setActiveFiltersCounter(newFilters.length);
        } else {
            const index = activeFilters.findIndex((obj) => obj.id === payload.id);
            if (index > -1) {
                const slicedFilters = activeFilters.slice();
                slicedFilters.splice(index,1);
                const splicedFilters = slicedFilters;

                setActiveFilters(splicedFilters);
                setActiveFiltersCounter(splicedFilters.length);
            }
        }

        if (payload.taxonomy === 'wprm_main_ingredient') {
            if (mainIngredients.includes(payload.id)) {
                const index = applyState.mainIngredients.indexOf(payload.id);
                if (index > -1) {
                    applyState.mainIngredients.splice(index, 1);
                }
                setCounter(counter - 1);
            } else {
                applyState.mainIngredients.push(payload.id);
                setCounter(counter + 1);
            }
        } else
        if (payload.taxonomy === 'wprm_course') {
            if (course.includes(payload.id)) {
                const index = applyState.course.indexOf(payload.id);
                if (index > -1) {
                    applyState.course.splice(index, 1);
                }
                setCounter(counter - 1);
            } else {
                applyState.course.push(payload.id);
                setCounter(counter + 1);
            }
        } else
        if (payload.taxonomy === 'wprm_difficulty') {
            if (effortLevel.includes(payload.id)) {
                const index = applyState.effortLevel.indexOf(payload.id);
                if (index > -1) {
                    applyState.effortLevel.splice(index, 1);
                }
                setCounter(counter - 1);
            } else {
                applyState.effortLevel.push(payload.id);
                setCounter(counter + 1);
            }
        } else
        if (payload.taxonomy === 'wprm_cooking_time') {
            if (cookingTime.includes(payload.id)) {
                const index = applyState.cookingTime.indexOf(payload.id);
                if (index > -1) {
                    applyState.cookingTime.splice(index, 1);
                }
                setCounter(counter - 1);
            } else {
                applyState.cookingTime.push(payload.id);
                setCounter(counter + 1);
            }
        } else
        if (payload.taxonomy === 'wprm_diet') {
            if (diet.includes(payload.id)) {
                const index = applyState.diet.indexOf(payload.id);
                if (index > -1) {
                    applyState.diet.splice(index, 1);
                }
                setCounter(counter - 1);
            } else {
                applyState.diet.push(payload.id);
                setCounter(counter + 1);
            }
        } else
        if (payload.taxonomy === 'wprm_fuel_type') {
            if (fuelType.includes(payload.id)) {
                const index = applyState.fuelType.indexOf(payload.id);
                if (index > -1) {
                    applyState.fuelType.splice(index, 1);
                }
                setCounter(counter - 1);
            } else {
                applyState.fuelType.push(payload.id);
                setCounter(counter + 1);
            }
        } else
        if (payload.taxonomy === 'wprm_featured') {
            if (featured.includes(payload.id)) {
                const index = applyState.featured.indexOf(payload.id);
                if (index > -1) {
                    applyState.featured.splice(index, 1);
                }
                setCounter(counter - 1);
            } else {
                applyState.featured.push(payload.id);
                setCounter(counter + 1);
            }
        } else
        if (payload.taxonomy === 'wprm_style') {
            if (style.includes(payload.id)) {
                const index = applyState.style.indexOf(payload.id);
                if (index > -1) {
                    applyState.style.splice(index, 1);
                }
                setCounter(counter - 1);
            } else {
                applyState.style.push(payload.id);
                setCounter(counter + 1);
            }
        }

        setApplyState(applyState);

        // Reenable the "Apply Filters" button
        setApplyFilters(false);
    }

    return (
        <Fragment>
            <div className="b-recipes-advanced-filter__checkbox-wrapper">
                <h5
                    className="b-recipes-advanced-filter__checkbox-wrapper__legend"
                    onClick={toggleAccordian}>
                    <img className="legend__icon" src={'/wp-content/themes/electro/img/svg/chevron-down.svg'} alt={'Chevron Down'}/>
                    <span>{label}</span>
                    {counter > 0 && (
                        <span>({counter})</span>
                    )}
                </h5>

                <div id={id} className="b-recipes-advanced-filter__checkbox-wrapper__accordian">
                    {options?.length > 0 && options.map((option, index) => {
                        const checked = activeFilters.some(el => el.name === option.name);
                        if (option.name === 'featured') {
                            option.name = 'Featured Recipes';
                        };
                        return (
                            <div key={index} className="b-recipes-advanced-filter__checkbox-wrapper__checkbox">
                                <label className="checkbox__container">
                                    <input
                                        type="checkbox"
                                        name={option.taxonomy}
                                        title={option.name}
                                        value={option.id}
                                        onChange={() => handleClick(option)}
                                        className="js-filter-checkbox"
                                        checked={checked}
                                    />
                                    <span className="checkbox__checkmark">
                                        <img
                                            src={'/wp-content/themes/electro/img/svg/checkmark.svg'}
                                            className={'checkmark__icon'}
                                            alt={'Checkbox'}
                                            height="18"
                                            width="18"
                                        />
                                    </span>
                                    {option.name}
                                </label>
                            </div>
                        );
                    })}
                </div>
            </div>
        </Fragment>
    );
};

export default CheckBoxes;
